import "./App.css";
import { useState } from "react";

function App() {
  const [Output, setmyOut] = useState({});
  const [Mat1, setMat1] = useState({});
  const [Mat2, setMat2] = useState({});
  const [row1, setrow1] = useState([1, 2, 1]);
  const [col1_row2, setcol1_row2] = useState([1, 2, 2]);
  const [col2, setcol2] = useState([1, 1, 1]);
  const Multiply = (r1, c1, r2, c2) => {
    let mul = {};
    for (let ele in Output) mul[ele] = 0;
    for (let i = 0; i < r1; i++)
      for (let j = 0; j < c2; j++)
        for (let k = 0; k < r2; k++)
          mul[`${i}${j}`] =
            +mul[`${i}${j}`] + +Mat1[`${i}${k}`] * +Mat2[`${k}${j}`];

    setmyOut({ ...mul });
  };
  const CreateMat = (updatematrix, mat, ip, row, col) => {
    return (
      <>
        <div style={{ margin: "1em" }}>
          {row.map((a, i) => {
            return (
              <div style={{ display: "flex" }}>
                {col.map((b, j) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        height: "80px",
                        boxSizing: "border-box",
                        width: "80px",
                        border: "1px solid",
                      }}
                    >
                      <input
                        disabled={!ip}
                        style={{
                          textAlign: "center",
                          boxSizing: "border-box",
                          overflow: "hidden",
                        }}
                        value={
                          mat.hasOwnProperty(`${i}${j}`)
                            ? Number(mat[`${i}${j}`])
                            : (mat[`${i}${j}`] = 0)
                        }
                        onChange={(event) => {
                          let obj = {};
                          obj[`${i}${j}`] = event.target.value;
                          updatematrix({ ...mat, ...obj });
                          // console.log(Mat1);
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </>
    );
  };
  const Slider = (row, col, setrow, setcol) => {
    return (
      <>
        <span>Rows {row.length}</span>
        <input
          type="range"
          value={row.length}
          min="1"
          max="5"
          id="slider"
          onChange={(event) => {
            let arr = [...Array(+event.target.value).keys()];
            setrow(arr);
          }}
        />
        <span>Cols {col.length}</span>
        <input
          type="range"
          min="1"
          value={col.length}
          max="5"
          id="slider"
          onChange={(event) => {
            let arr = [...Array(+event.target.value).keys()];
            setcol(arr);
          }}
        />
      </>
    );
  };
  return (
    <div
      className="main"
      style={{
        display: "flex",
        "align-items": "center",
        "justify-content": "space-around",
        "min-height": "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {Slider(row1, col1_row2, setrow1, setcol1_row2)}
        {CreateMat(setMat1, Mat1, 1, row1, col1_row2)}
      </div>
      <h1>x</h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {Slider(col1_row2, col2, setcol1_row2, setcol2)}
        {CreateMat(setMat2, Mat2, 1, col1_row2, col2)}
      </div>{" "}
      <div>
        <button
          onClick={() =>
            Multiply(
              row1.length,
              col1_row2.length,
              col1_row2.length,
              col2.length
            )
          }
        >
          =
        </button>
      </div>
      {CreateMat(setmyOut, Output, 0, row1, col2)}
    </div>
  );
}
export default App;
